import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoginForm from './LoginForm';
import styles from './Login.module.css';
import NotFound from '../NotFound';
import { UserContext } from '../../UserContext';
import EsqueceuSenha from './EsqueceuSenha';

const Login = () => {
  const { login } = React.useContext(UserContext);

  if (login === true) return <Navigate to="/user" />;
  return (
    <section className={styles.login}>
      <div className={styles.forms}>
        <Routes>
          <Route path="/" element={<LoginForm />} />
          <Route path="forgotPassword" element={<EsqueceuSenha />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </section>
  );
};

export default Login;
